import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
/**
 * Form の値を管理する Context
 */
const Context = createContext({
    formValues: null,
    setFormValues: () => {
        // eslint-disable-next-line no-console
        console.error('HotlineClientCreateFormContext: setFormValues is not defined');
    },
});
/**
 * Context を使用するための Hook
 */
export const useHotlineClientCreateFormContext = () => useContext(Context);
/**
 * Context を使用するための Provider
 */
export const HotlineClientCreateFormContextProvider = (props) => {
    const { children } = props;
    // Form の値 state 管理
    const [formValues, setFormValues] = useState(null);
    const value = useMemo(() => ({ formValues, setFormValues }), [formValues]);
    return _jsx(Context.Provider, Object.assign({ value: value }, { children: children }));
};
